export const MAX_DWEB_WIDTH = 1440;

// 96 being the sum of fixed margin from both sides
export const GUTTER_SPACE = 96;

//1344 is (1440(which is out max width of the layout) - 96)
export const BANNER_WIDTH = 1344;

export const SLIDE_COUNT_TEXT = 'of';

export const DEFAULT_IMAGE_WIDTH = 1500;
